import React from 'react';
import PropTypes from 'prop-types';
import { StyledButton } from './components/ButtonStyles';
import { useButton } from './hooks/useButton';
import { getAriaLabel, hasLoadingState, resolveIconClass } from './utils/buttonHelpers';
import Spinner from '../Spinner';
import Icon from '../Icon';

const Button = ({ variant, size, shape, disabled, onClick, children, ariaLabel, loading, icon, rightIcon, iconButton, as, ...rest }) => {
  const { handleClick } = useButton({ onClick, disabled: disabled || loading });
  const label = getAriaLabel(ariaLabel, children);
  const isLoading = hasLoadingState(loading);

  return (
    <StyledButton
      as={as}
      variant={variant}
      size={size}
      shape={shape}
      disabled={disabled || isLoading}
      loading={isLoading}
      iconButton={iconButton}
      onClick={handleClick}
      aria-label={label}
      {...rest}
    >
      {isLoading && <Spinner size={size === 'xs' ? 'xs' : 'sm'} color="inherit" />}
      {!isLoading && icon && <Icon className={resolveIconClass(icon)} size={size} color="inherit" />}
      {children}
      {!isLoading && rightIcon && <Icon className={resolveIconClass(rightIcon)} size={size} color="inherit" />}
    </StyledButton>
  );
};

Button.propTypes = {
  variant: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'negative',
    'success',
    'warning',
    'danger',
    'info',
    'light',
    'dark',
    'text',
  ]),
  size: PropTypes.oneOf(['xs', 'sm', 'md', 'lg']),
  shape: PropTypes.oneOf(['rectangle', 'rounded']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  icon: PropTypes.string,
  rightIcon: PropTypes.string,
  iconButton: PropTypes.bool,
  as: PropTypes.string,
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  children: PropTypes.node,
};

Button.defaultProps = {
  variant: 'primary',
  size: 'sm',
  shape: 'rectangle',
  disabled: false,
  loading: false,
  icon: undefined,
  rightIcon: undefined,
  iconButton: false,
  as: undefined,
  ariaLabel: undefined,
  onClick: undefined,
  children: null,
};

export default Button;



// WEBPACK FOOTER //
// ./src/design-system/atoms/Button/Button.jsx